import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_emoji-3",
  "use": "svg_emoji-3-usage",
  "viewBox": "0 0 61 55",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 61 55\" id=\"svg_emoji-3\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M30.5 54.794C13.978 54.794.535 41.353.535 24.829h10.162c0 10.919 8.884 19.804 19.803 19.804s19.803-8.885 19.803-19.804h10.162c0 16.524-13.443 29.965-29.965 29.965Zm30-48.241a6.015 6.015 0 1 1-12.03 0 6.015 6.015 0 0 1 12.03 0Zm-60 4.1h12.876v-7.82H.5v7.82Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol